/* eslint-disable */
<template>
  <div>
    <vx-card class="mb-8">
      <!-- SEARCH BAR -->
      <vs-row vs-type="flex" >
        <vs-col vs-lg="8" vs-sm="12" vs-xs="12" >
          <vs-row  vs-type="flex" >
            <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
              <span>Nome</span>
              <vs-input class="w-full d-theme-input-dark-bg" v-model="name" @keyup.enter="refine(cnpj, name, null)" @keyup.esc="refine(cnpj, name)" />
            </vs-col>
            <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
              <span>Cnpj</span>
              <CnpjInput class="w-full d-theme-input-dark-bg" v-model="cnpj" @keyup.enter="refine(cnpj, name, null)" @keyup.esc="refine(cnpj, name)" />
            </vs-col>
            <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
              <span>Setores</span>
              <vs-select
                v-model="sector.name"
                autocomplete
                class="w-full">
                <vs-select-item :key="index" :value="item.name" :text="item.name" v-for="(item, index) in sectors" />
              </vs-select>
            </vs-col>
          </vs-row>
        </vs-col>

        <vs-col vs-lg="4" vs-sm="12" vs-xs="12" vs-align="center" class="mt-4">
          <vs-row vs-align="center" >
            <vs-col vs-lg="5" vs-sm="5" vs-xs="12" class="mt-1">
              <vs-button class="w-full" @click="clearFilter()" icon-pack="fa" icon="fa-eraser" title="Limpar">
                <span class="auto-hide-clear-text" >Limpar</span>
              </vs-button>
            </vs-col>
            <vs-col vs-lg="5" vs-sm="5" vs-xs="12" class="mt-1">
              <vs-button class="w-full" @click="refine(cnpj, name, sector.name)" icon="search">Buscar</vs-button>
            </vs-col>
            <vs-col vs-lg="2" vs-sm="2" vs-xs="12" class="mt-1">
              <button
                v-if="isAuthorized('COMPANY_ADD')"
                name="button"
                @click="addEmpresa()"
                class="ml-3 vs-component vs-button vs-button-primary vs-button-filled includeIcon includeIconOnly vs-radius">
                <feather-icon icon="PlusIcon" svgClasses="w-4 h-4"></feather-icon>
              </button>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>

    </vx-card>

    <vx-card>

        <vs-table stripe :data="companies" noDataText="Nenhum registro encontrado.">

          <template slot="thead">
            <th>Nome</th>
            <th>CNPJ</th>
            <th>Classificação Nacional de Atividades Econômicas</th>
            <th>Última Nota</th>
            <th>Data</th>
            <th>Tipo</th>
            <th>Fonte</th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(row, indextr) in data">
              <td>
                <a role="button" style="cursor: pointer" @click="view(row)">{{row.name}}</a>
              </td>
              <td>
                {{(row.cnpjAlfa || row.cnpj) | formatCnpj}}
              </td>
              <td>
                <span v-if="row.cnae != null">{{row.cnae || '---'}} </span>
                <span v-else>---</span>
              </td>
              <td>
                <span v-if="row.lastScore">{{ row.lastScore }}</span>
                <span v-else>---</span>
              </td>
              <td>
                <span v-if="row.lastBalance">{{ row.lastBalance }}</span>
                <span v-else>---</span>
              </td>
              <td>
                <span v-if="row.scoreCard">{{ row.scoreCard }}</span>
                <span v-else>---</span>
              </td>
              <td>
                <span v-if="row.lastBalanceScr">{{ row.lastBalanceScr }}</span>
                <span v-else>---</span>
              </td>
            </vs-tr>
          </template>

        </vs-table>

        <div class="my-5">
          <vs-pagination
            v-model="page"
            :total="totalPages">
          </vs-pagination>
        </div>

    </vx-card>

  </div>
</template>

<script>
import axios from 'axios'
import CnpjInput from '@/components/CnpjInput'
import UserAuthorization from '@/mixins/UserAuthorization'

export default {
  mixins:[UserAuthorization],
  components: {
    CnpjInput
  },
  data () {
    return {
      cnpj: null,
      name: null,
      sectors: [],
      companies: [],
      sector: {
        code: null,
        name: null
      },
      page: 1,
      totalPages: 0
    }
  },
  watch: {
    page () {
      this.loadCompanies()
    }
  },
  beforeMount () {
    this.loadCompanies()
    this.loadSectors()
  },
  mounted () {
    this.refresh()
  },
  methods: {

    refresh () {
      this.loadCompanies()
    },

    loadSectors () {
      axios.get(`${process.env.VUE_APP_API  }/api/v1/sector`)
        .then((response) => {
          this.sectors = response.data
        })
    },

    loadCompanies () {
      axios.get(`${process.env.VUE_APP_API  }/api/v1/companies`,
        {
          params: {
            name: this.name,
            cnpj: this.cnpj,
            sectorName: this.sector.name,
            page: this.page - 1
          }
        })
        .then((response) => {
          this.companies = response.data.content
          this.totalPages = response.data.totalPages
        })

    },
    view (row) {
      this.$router.push({path: `/balanco/${row.guid}`})
    },
    addEmpresa () {
      this.$router.push({path: '/empresa-add'})
    },
    refine (cnpj, name, sectorName) {
      this.cnpj = cnpj
      this.name = name
      this.sector.name = sectorName
      this.page = 1
      this.refresh()
    },
    clearFilter () {
      this.cnpj = null
      this.name = ''
      this.sector.name = null
      this.page = 1
      this.refresh()
    }
  }
}

</script>
